import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { ErrorResponse } from './classes/error';
import { OneToNEnroll } from './classes/one-to-n-enroll';
@Component({
  selector: 'jaakrecog-enroll',
  template: `
    <lib-capture-video
      *ngIf="showComponent"
      [userData]="userData"
      [accessToken]="accessToken"
      (getResult)="emitResult($event)"
    ></lib-capture-video>
  `,
  styles: [],
})
export class EnrollComponent implements OnInit {
  @Input() userData: any;
  @Input() accessToken!: string;
  @Output() getResponse: OneToNEnroll | ErrorResponse | any =
    new EventEmitter();
  showComponent: boolean = true;
  constructor() {
    let scriptTag = document.createElement('script');
    scriptTag.src =
      'https://storage.googleapis.com/jaakrecog-storage-front/js/face-api.min.js';
    document.body.appendChild(scriptTag);
  }

  ngOnInit(): void {}

  emitResult(ev: any): void {
    this.showComponent = false;
    this.getResponse.emit(ev);
    setTimeout(() => {
      this.showComponent = true;
    }, 1000);
  }
}
